import { render, staticRenderFns } from "./companyrules.vue?vue&type=template&id=7517d735"
import script from "./companyrules.vue?vue&type=script&lang=js"
export * from "./companyrules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports